import React from 'react'
import cx from 'classnames'
import { GlobalBannerProps } from 'src/interfaces/GlobalBanner'
import { Serializer } from 'src/utils/serializer'
import BlockContent from '../BlockContent'

export interface BannerProps {
  globalBannerProps: GlobalBannerProps | undefined
  classes: any
  globalBannerVariant?: 'control' | 'treatment'
}

export const GlobalBanner = ({
  globalBannerProps: config,
  classes,
  globalBannerVariant: variant,
}: BannerProps) => {

  if (!config) return null

  if (!variant) return null

  /**
   * Get the settings for the global banner
   * The settings are stored in the globalBannerProps object
   */
  const settings = config[variant]

  if (!settings || Object.keys(settings).length === 0) {
    return null
  }

  const isBackgroundColor = (value: string) => {
    return settings && settings.backgroundColor === value
  }

  return (
    <div
      className={cx(classes.banner, {
        [classes.bgPrimary1]: isBackgroundColor('primary-1'),
        [classes.bgPrimary2]: isBackgroundColor('primary-2'),
        [classes.bgPrimary3]: isBackgroundColor('primary-3'),
        [classes.bgSecondary1]: isBackgroundColor('secondary-1'),
        [classes.bgSecondary2]: isBackgroundColor('secondary-2'),
        [classes.bgSecondary3]: isBackgroundColor('secondary-3'),
        [classes.bgSecondary4]: isBackgroundColor('secondary-4'),
        [classes.bgSecondary5]: isBackgroundColor('secondary-5'),
        [classes.bgSecondary6]: isBackgroundColor('secondary-6'),
        [classes.bgTertiary1]: isBackgroundColor('tertiary-1'),
        [classes.bgTertiary2]: isBackgroundColor('tertiary-2'),
        [classes.bgTertiary3]: isBackgroundColor('tertiary-3'),
        [classes.bgTertiary4]: isBackgroundColor('tertiary-4'),
      })}
    >
      <div className={classes.bannerContent}>
        <BlockContent blocks={settings.text} serializers={Serializer} />
      </div>
    </div>
  )
}

export default GlobalBanner